// extracted by mini-css-extract-plugin
module.exports = {"day":"WeekDay_day__2OsdJ"};